export default "__VITE_ASSET__DfoMSj2V__"